import React, { useState, useEffect } from 'react';
import { supabase } from '../../../config/supabase';
import { apiUrl } from '../../../config/supabase';
import { contentSave, contentDelete } from '../../../config/adminApi';

const empToken = () => { try { return localStorage.getItem('emp_token') || ''; } catch { return ''; } };

const C = {
  primary: '#5a67d8', purple: '#764ba2', green: '#16a34a',
  red: '#dc2626', amber: '#d97706', cyan: '#0891b2',
  text: '#1f2937', muted: '#6b7280', border: '#e5e7eb',
  bg: '#f9fafb', white: '#ffffff',
};

// ── مصادر البيانات المتاحة ─────────────────────────────────
const SOURCES = {
  payments: {
    label: '💳 الدفعات', table: 'payments',
    joins: { customers: 'customer_id', courses: 'course_id' },
    fields: [
      { key: 'created_at',   label: 'التاريخ',        type: 'date' },
      { key: 'amount',       label: 'المبلغ',          type: 'number' },
      { key: 'method',       label: 'طريقة الدفع',     type: 'text' },
      { key: 'status',       label: 'الحالة',          type: 'text' },
      { key: 'receipt_note', label: 'رقم المعاملة',    type: 'text' },
      { key: 'customer_name',label: 'اسم العميل',      type: 'text', join: 'customers' },
      { key: 'customer_email',label:'إيميل العميل',    type: 'text', join: 'customers' },
      { key: 'course_name',  label: 'الكورس',          type: 'text', join: 'courses' },
    ],
  },
  customers: {
    label: '👥 العملاء', table: 'customers',
    fields: [
      { key: 'name',       label: 'الاسم',            type: 'text' },
      { key: 'email',      label: 'الإيميل',          type: 'text' },
      { key: 'phone',      label: 'الموبايل',         type: 'text' },
      { key: 'created_at', label: 'تاريخ التسجيل',    type: 'date' },
    ],
  },
  courses: {
    label: '📚 الكورسات', table: 'courses',
    fields: [
      { key: 'name_ar',  label: 'اسم الكورس عربي',   type: 'text' },
      { key: 'name_en',  label: 'اسم الكورس إنجليزي',type: 'text' },
      { key: 'price',    label: 'السعر',              type: 'number' },
      { key: 'icon',     label: 'الأيقونة',           type: 'text' },
    ],
  },
  employees: {
    label: '👨‍💼 الموظفين', table: 'employees',
    fields: [
      { key: 'name_ar',   label: 'الاسم عربي',       type: 'text' },
      { key: 'name_en',   label: 'الاسم إنجليزي',    type: 'text' },
      { key: 'username',  label: 'اسم المستخدم',     type: 'text' },
      { key: 'is_active', label: 'الحالة',            type: 'boolean' },
    ],
  },
  enrollments: {
    label: '✅ الاشتراكات', table: 'enrollments',
    joins: { customers: 'customer_id', courses: 'course_id' },
    fields: [
      { key: 'status',        label: 'الحالة',        type: 'text' },
      { key: 'paid_at',       label: 'تاريخ الدفع',  type: 'date' },
      { key: 'customer_name', label: 'العميل',        type: 'text', join: 'customers' },
      { key: 'course_name',   label: 'الكورس',        type: 'text', join: 'courses' },
    ],
  },
  user_activity_logs: {
    label: '📋 نشاط المستخدمين', table: 'user_activity_logs',
    fields: [
      { key: 'customer_name',  label: 'المستخدم',    type: 'text' },
      { key: 'customer_email', label: 'الإيميل',     type: 'text' },
      { key: 'action',         label: 'الإجراء',     type: 'text' },
      { key: 'entity_name',    label: 'التفاصيل',    type: 'text' },
      { key: 'created_at',     label: 'الوقت',       type: 'date' },
    ],
  },
  employee_sessions: {
    label: '🕐 جلسات الموظفين', table: 'employee_sessions',
    fields: [
      { key: 'employee_name', label: 'الموظف',       type: 'text' },
      { key: 'employee_role', label: 'الوظيفة',      type: 'text' },
      { key: 'action',        label: 'الإجراء',      type: 'text' },
      { key: 'session_start', label: 'وقت البداية',  type: 'date' },
      { key: 'session_end',   label: 'وقت الانتهاء', type: 'date' },
    ],
  },
};

const FILTER_OPS = {
  text:    [{ v: 'contains', l: 'يحتوي' }, { v: 'equals', l: 'يساوي' }, { v: 'not_empty', l: 'غير فارغ' }],
  number:  [{ v: 'gt', l: '>' }, { v: 'lt', l: '<' }, { v: 'eq', l: '=' }, { v: 'gte', l: '>=' }, { v: 'lte', l: '<=' }],
  date:    [{ v: 'after', l: 'بعد' }, { v: 'before', l: 'قبل' }, { v: 'between', l: 'بين' }],
  boolean: [{ v: 'true', l: 'نعم' }, { v: 'false', l: 'لا' }],
};

const INP = {
  padding: '7px 10px', border: `1px solid ${C.border}`,
  borderRadius: '8px', fontSize: '13px', color: C.text,
  background: C.white, outline: 'none', boxSizing: 'border-box',
  width: '100%', fontFamily: 'Cairo, Arial, sans-serif',
};

const today = () => new Date().toISOString().split('T')[0];
const monthAgo = () => { const d = new Date(); d.setMonth(d.getMonth()-1); return d.toISOString().split('T')[0]; };
const fmtDate = d => d ? new Date(d).toLocaleString('ar-EG', { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' }) : '—';

// ══════════════════════════════════════════════════════════
export default function ReportBuilder({ onBack, payments, customers, courses, employees, enrollments }) {

  // ── بيانات الباني ──
  const [step,          setStep]          = useState(1); // 1=اختار مصدر، 2=اختار حقول، 3=فلاتر، 4=نتيجة
  const [source,        setSource]        = useState('');
  const [selectedCols,  setSelectedCols]  = useState([]);
  const [filters,       setFilters]       = useState([]);
  const [sortBy,        setSortBy]        = useState('');
  const [sortDir,       setSortDir]       = useState('desc');
  const [reportName,    setReportName]    = useState('');
  const [limit,         setLimit]         = useState(100);

  // ── نتائج + حفظ ──
  const [results,    setResults]    = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [savedReps,  setSavedReps]  = useState([]);
  const [showSaved,  setShowSaved]  = useState(false);
  const [runDone,    setRunDone]    = useState(false);

  useEffect(() => {
    supabase.from('saved_reports').select('*').order('created_at', { ascending: false })
      .then(({ data }) => { if (data) setSavedReps(data); });
  }, []);

  const srcDef = SOURCES[source];
  const availableFields = srcDef?.fields || [];

  const toggleCol = (key) => {
    setSelectedCols(p => p.includes(key) ? p.filter(k => k !== key) : [...p, key]);
  };

  const addFilter = () => {
    const firstField = availableFields[0];
    if (!firstField) return;
    setFilters(p => [...p, { field: firstField.key, op: FILTER_OPS[firstField.type]?.[0]?.v || 'contains', value: '', value2: '' }]);
  };

  const updateFilter = (i, patch) => setFilters(p => p.map((f, idx) => idx === i ? { ...f, ...patch } : f));
  const removeFilter = (i) => setFilters(p => p.filter((_, idx) => idx !== i));

  // ── تشغيل التقرير ──
  const runReport = async () => {
    if (!source || selectedCols.length === 0) return;
    setLoading(true); setRunDone(false);

    try {
      const res = await fetch(apiUrl('/api/admin/report-data'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: empToken(),
          table: SOURCES[source].table,
          filters: filters.map(f => ({ field: f.field, op: f.op, value: f.value, value2: f.value2 })),
          sortBy, sortDir, limit,
        }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok || !j.ok) { alert(j.message || 'فشل تشغيل التقرير'); setLoading(false); return; }
      const raw = j.rows || [];

      // إضافة بيانات الـ joins من الـ props
      const enriched = (raw || []).map(row => {
        const out = { ...row };
        if (source === 'payments' || source === 'enrollments') {
          const cust = customers?.find(c => c.id === row.customer_id);
          const course = courses?.find(c => c.id === row.course_id);
          if (cust) { out.customer_name = cust.name; out.customer_email = cust.email; }
          if (course) { out.course_name = course.name_ar; }
        }
        return out;
      });

      setResults(enriched);
      setRunDone(true);
      setStep(4);
    } catch (e) {
      alert('خطأ في تشغيل التقرير: ' + e.message);
    }
    setLoading(false);
  };

  // ── حفظ التقرير ──
  const saveReport = async () => {
    if (!reportName.trim()) { alert('أدخل اسم التقرير'); return; }
    setSaving(true);
    const config = { source, selectedCols, filters, sortBy, sortDir, limit };
    const r = await contentSave('saved_reports', {
      name: reportName.trim(),
      source, config,
      created_at: new Date().toISOString(),
    });
    if (r.ok && r.row) setSavedReps(p => [r.row, ...p]);
    setSaving(false);
    if (r.error) { alert(r.error); return; }
    alert('✅ تم حفظ التقرير في قائمة التقارير');
  };

  // ── تحميل تقرير محفوظ ──
  const loadSavedReport = (rep) => {
    const { source: s, selectedCols: sc, filters: f, sortBy: sb, sortDir: sd, limit: l } = rep.config || {};
    setSource(s || ''); setSelectedCols(sc || []); setFilters(f || []);
    setSortBy(sb || ''); setSortDir(sd || 'desc'); setLimit(l || 100);
    setReportName(rep.name); setShowSaved(false); setStep(3); setRunDone(false);
  };

  // ── طباعة ──
  const handlePrint = () => {
    const cols = availableFields.filter(f => selectedCols.includes(f.key));
    const w = window.open('', '_blank');
    w.document.write(`<html><head><title>${reportName||'تقرير'}</title>
    <style>body{font-family:Arial,sans-serif;direction:rtl;font-size:11px;}
    h2{color:#5a67d8;}table{width:100%;border-collapse:collapse;margin-top:12px;}
    th{background:#5a67d8;color:white;padding:6px 8px;text-align:right;}
    td{border:1px solid #e5e7eb;padding:5px 8px;}tr:nth-child(even){background:#f9fafb;}
    .footer{margin-top:12px;font-size:10px;color:#6b7280;text-align:center;border-top:1px solid #e5e7eb;padding-top:8px;}
    </style></head><body>`);
    w.document.write(`<h2>${reportName||'تقرير مخصص'}</h2>`);
    w.document.write(`<p style="color:#6b7280;font-size:11px">طُبع: ${new Date().toLocaleString('ar-EG')} | عدد السجلات: ${results.length}</p>`);
    w.document.write('<table><thead><tr>');
    cols.forEach(c => w.document.write(`<th>${c.label}</th>`));
    w.document.write('</tr></thead><tbody>');
    results.forEach(row => {
      w.document.write('<tr>');
      cols.forEach(c => {
        let val = row[c.key] ?? '—';
        if (c.type === 'date' && val && val !== '—') val = fmtDate(val);
        if (c.key === 'status') val = val === 'active'||val==='approved'?'مكتمل':val==='pending'?'معلق':'مرفوض';
        if (c.key === 'method') val = val==='card'?'كارت':val==='vodafone'?'فودافون':'تحويل';
        if (c.key === 'is_active') val = val?'نشط':'موقوف';
        w.document.write(`<td>${val}</td>`);
      });
      w.document.write('</tr>');
    });
    w.document.write('</tbody></table>');
    w.document.write(`<div class="footer">الجوهرة Academy — ${results.length} سجل</div>`);
    w.document.write('</body></html>');
    w.document.close(); w.print();
  };

  // ── export CSV ──
  const exportCSV = () => {
    const cols = availableFields.filter(f => selectedCols.includes(f.key));
    const header = cols.map(c => c.label).join(',');
    const rows = results.map(row => cols.map(c => {
      let val = row[c.key] ?? '';
      if (c.type === 'date' && val) val = fmtDate(val);
      return `"${String(val).replace(/"/g, '""')}"`;
    }).join(','));
    const csv = '\uFEFF' + [header, ...rows].join('\n');
    const a = document.createElement('a');
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    a.download = `${reportName||'تقرير'}-${today()}.csv`;
    a.click();
  };

  // ══════════════════════════════════════════
  // RENDER
  // ══════════════════════════════════════════
  const stepStyle = (s) => ({
    padding: '8px 20px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold',
    background: step >= s ? C.primary : C.bg, color: step >= s ? '#fff' : C.muted,
    border: `1px solid ${step >= s ? C.primary : C.border}`, cursor: step >= s ? 'pointer' : 'default',
  });

  return (
    <div style={{ fontFamily: 'Cairo, Arial, sans-serif', direction: 'rtl' }}>

      {/* هيدر */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '16px', padding: '20px 24px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: C.primary }}>🔧 صانع التقارير</h2>
          <p style={{ margin: '3px 0 0', color: C.muted, fontSize: '12px' }}>ابني تقريرك الخاص من الصفر</p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => setShowSaved(!showSaved)}
            style={{ padding: '8px 16px', background: '#eef2ff', color: C.primary, border: `1px solid #c7d2fe`, borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
            📂 التقارير المحفوظة ({savedReps.length})
          </button>
          <button onClick={onBack}
            style={{ padding: '8px 14px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', fontSize: '13px', cursor: 'pointer', color: C.text }}>
            ← رجوع
          </button>
        </div>
      </div>

      {/* التقارير المحفوظة */}
      {showSaved && (
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
          <h3 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: 'bold', color: C.text }}>📂 التقارير المحفوظة</h3>
          {savedReps.length === 0
            ? <p style={{ color: C.muted, fontSize: '13px', margin: 0 }}>لا توجد تقارير محفوظة بعد</p>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {savedReps.map(r => (
                  <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: C.bg, borderRadius: '8px', border: `1px solid ${C.border}` }}>
                    <div>
                      <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', color: C.text }}>{r.name}</p>
                      <p style={{ margin: 0, fontSize: '11px', color: C.muted }}>{SOURCES[r.source]?.label} — {new Date(r.created_at).toLocaleDateString('ar-EG')}</p>
                    </div>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => loadSavedReport(r)}
                        style={{ padding: '6px 14px', background: C.primary, color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>تحميل</button>
                      <button onClick={async () => { const rr = await contentDelete('saved_reports', r.id); if (rr.error) { alert(rr.error); return; } setSavedReps(p => p.filter(x => x.id !== r.id)); }}
                        style={{ padding: '6px 10px', background: '#fee2e2', color: C.red, border: 'none', borderRadius: '6px', cursor: 'pointer' }}>✕</button>
                    </div>
                  </div>
                ))}
              </div>
          }
        </div>
      )}

      {/* خطوات */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
        {[
          [1, '① اختار المصدر'],
          [2, '② اختار الحقول'],
          [3, '③ الفلاتر والترتيب'],
          [4, '④ النتيجة'],
        ].map(([s, l]) => (
          <button key={s} style={stepStyle(s)} onClick={() => step >= s && setStep(s)}>{l}</button>
        ))}
      </div>

      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '20px' }}>

        {/* ── الخطوة 1: اختار المصدر ── */}
        {step === 1 && (
          <div>
            <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: C.text }}>من أين تريد البيانات؟</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px' }}>
              {Object.entries(SOURCES).map(([key, src]) => (
                <div key={key} onClick={() => { setSource(key); setSelectedCols([]); setFilters([]); setStep(2); }}
                  style={{ padding: '16px', border: `2px solid ${source === key ? C.primary : C.border}`, borderRadius: '12px', cursor: 'pointer', textAlign: 'center', background: source === key ? '#eef2ff' : C.bg, transition: 'all 0.15s' }}>
                  <div style={{ fontSize: '24px', marginBottom: '6px' }}>{src.label.split(' ')[0]}</div>
                  <div style={{ fontSize: '13px', fontWeight: 'bold', color: source === key ? C.primary : C.text }}>{src.label.slice(2)}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── الخطوة 2: اختار الحقول ── */}
        {step === 2 && srcDef && (
          <div>
            <h3 style={{ margin: '0 0 4px', fontSize: '15px', color: C.text }}>اختار الحقول اللي عايز تشوفها</h3>
            <p style={{ margin: '0 0 16px', color: C.muted, fontSize: '12px' }}>من {srcDef.label}</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '8px', marginBottom: '20px' }}>
              {availableFields.map(f => (
                <div key={f.key} onClick={() => toggleCol(f.key)}
                  style={{ padding: '10px 14px', border: `2px solid ${selectedCols.includes(f.key) ? C.primary : C.border}`, borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', background: selectedCols.includes(f.key) ? '#eef2ff' : C.white }}>
                  <span style={{ fontSize: '18px', width: '20px', height: '20px', border: `2px solid ${selectedCols.includes(f.key) ? C.primary : C.border}`, borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.primary, fontSize: '12px', fontWeight: 'bold', flexShrink: 0 }}>
                    {selectedCols.includes(f.key) ? '✓' : ''}
                  </span>
                  <div>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: '600', color: selectedCols.includes(f.key) ? C.primary : C.text }}>{f.label}</p>
                    <p style={{ margin: 0, fontSize: '10px', color: C.muted }}>{f.join ? '🔗 من جدول آخر' : f.type}</p>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => setStep(1)} style={{ padding: '10px 20px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>← رجوع</button>
              <button onClick={() => setStep(3)} disabled={selectedCols.length === 0}
                style={{ padding: '10px 24px', background: selectedCols.length ? C.primary : '#9CA3AF', color: '#fff', border: 'none', borderRadius: '8px', cursor: selectedCols.length ? 'pointer' : 'not-allowed', fontSize: '13px', fontWeight: 'bold' }}>
                التالي: الفلاتر →
              </button>
              <span style={{ fontSize: '12px', color: C.muted, alignSelf: 'center' }}>{selectedCols.length} حقل مختار</span>
            </div>
          </div>
        )}

        {/* ── الخطوة 3: الفلاتر والترتيب ── */}
        {step === 3 && srcDef && (
          <div>
            <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: C.text }}>الفلاتر والترتيب (اختياري)</h3>

            {/* اسم التقرير */}
            <div style={{ marginBottom: '16px', background: '#fef9ff', border: '1px solid #e9d5ff', borderRadius: '10px', padding: '14px' }}>
              <label style={{ fontSize: '12px', fontWeight: 'bold', color: C.muted, display: 'block', marginBottom: '6px' }}>🏷️ اسم التقرير</label>
              <input value={reportName} onChange={e => setReportName(e.target.value)}
                placeholder="مثال: تقرير إيرادات مارس 2026"
                style={{ ...INP }} />
            </div>

            {/* الفلاتر */}
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: 'bold', color: C.text }}>🔍 الفلاتر</label>
                <button onClick={addFilter}
                  style={{ padding: '5px 14px', background: '#eef2ff', color: C.primary, border: `1px solid #c7d2fe`, borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>
                  + إضافة فلتر
                </button>
              </div>
              {filters.length === 0
                ? <p style={{ color: C.muted, fontSize: '12px', margin: 0 }}>لا توجد فلاتر — التقرير هيجيب كل البيانات</p>
                : filters.map((f, i) => {
                    const fieldDef = availableFields.find(fd => fd.key === f.field);
                    const ops = FILTER_OPS[fieldDef?.type || 'text'] || [];
                    return (
                      <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap', alignItems: 'center', background: C.bg, padding: '10px', borderRadius: '8px' }}>
                        <select value={f.field} onChange={e => { const fd = availableFields.find(x=>x.key===e.target.value); updateFilter(i, { field: e.target.value, op: FILTER_OPS[fd?.type||'text']?.[0]?.v||'contains', value: '', value2: '' }); }}
                          style={{ ...INP, width: '160px' }}>
                          {availableFields.map(fd => <option key={fd.key} value={fd.key}>{fd.label}</option>)}
                        </select>
                        <select value={f.op} onChange={e => updateFilter(i, { op: e.target.value })}
                          style={{ ...INP, width: '110px' }}>
                          {ops.map(op => <option key={op.v} value={op.v}>{op.l}</option>)}
                        </select>
                        {f.op !== 'not_empty' && f.op !== 'true' && f.op !== 'false' && (
                          <input value={f.value} onChange={e => updateFilter(i, { value: e.target.value })}
                            type={fieldDef?.type === 'date' ? 'date' : fieldDef?.type === 'number' ? 'number' : 'text'}
                            placeholder="القيمة"
                            style={{ ...INP, width: '140px' }} />
                        )}
                        {f.op === 'between' && (
                          <input value={f.value2} onChange={e => updateFilter(i, { value2: e.target.value })}
                            type="date" placeholder="إلى"
                            style={{ ...INP, width: '140px' }} />
                        )}
                        <button onClick={() => removeFilter(i)}
                          style={{ padding: '7px 10px', background: '#fee2e2', color: C.red, border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', flexShrink: 0 }}>✕</button>
                      </div>
                    );
                  })
              }
            </div>

            {/* ترتيب + عدد */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '10px', marginBottom: '20px' }}>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 'bold', color: C.muted, display: 'block', marginBottom: '4px' }}>ترتيب حسب</label>
                <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={INP}>
                  <option value="">الافتراضي</option>
                  {availableFields.filter(f => !f.join).map(f => <option key={f.key} value={f.key}>{f.label}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 'bold', color: C.muted, display: 'block', marginBottom: '4px' }}>الاتجاه</label>
                <select value={sortDir} onChange={e => setSortDir(e.target.value)} style={INP}>
                  <option value="desc">تنازلي (الأحدث أولاً)</option>
                  <option value="asc">تصاعدي (الأقدم أولاً)</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 'bold', color: C.muted, display: 'block', marginBottom: '4px' }}>عدد السجلات</label>
                <select value={limit} onChange={e => setLimit(Number(e.target.value))} style={{ ...INP, width: '90px' }}>
                  {[50, 100, 200, 500, 1000].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => setStep(2)} style={{ padding: '10px 20px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>← رجوع</button>
              <button onClick={runReport} disabled={loading}
                style={{ padding: '10px 28px', background: loading ? '#9CA3AF' : `linear-gradient(135deg,${C.primary},${C.purple})`, color: '#fff', border: 'none', borderRadius: '8px', cursor: loading ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: 'bold' }}>
                {loading ? '⏳ جاري التشغيل...' : '▶ تشغيل التقرير'}
              </button>
            </div>
          </div>
        )}

        {/* ── الخطوة 4: النتيجة ── */}
        {step === 4 && runDone && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '15px', color: C.text }}>{reportName || 'تقرير مخصص'}</h3>
                <p style={{ margin: '3px 0 0', color: C.muted, fontSize: '12px' }}>{results.length} سجل — {SOURCES[source]?.label}</p>
              </div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <button onClick={handlePrint}
                  style={{ padding: '8px 14px', background: C.primary, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>🖨️ طباعة</button>
                <button onClick={exportCSV}
                  style={{ padding: '8px 14px', background: C.green, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>📊 Excel/CSV</button>
                <button onClick={saveReport} disabled={saving}
                  style={{ padding: '8px 14px', background: C.amber, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', opacity: saving ? 0.7 : 1 }}>
                  {saving ? '⏳...' : '💾 حفظ التقرير'}
                </button>
                <button onClick={() => { setStep(3); }}
                  style={{ padding: '8px 14px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', fontSize: '12px', cursor: 'pointer', color: C.text }}>← تعديل</button>
              </div>
            </div>

            {/* الجدول */}
            {results.length === 0
              ? <p style={{ textAlign: 'center', color: C.muted, padding: '40px' }}>لا توجد نتائج بهذه الفلاتر</p>
              : (
                <div style={{ overflowX: 'auto', border: `1px solid ${C.border}`, borderRadius: '10px' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '400px' }}>
                    <thead>
                      <tr style={{ background: `linear-gradient(135deg,${C.primary},${C.purple})` }}>
                        <th style={{ padding: '9px 12px', color: '#fff', fontWeight: 'bold', textAlign: 'right', borderLeft: '1px solid rgba(255,255,255,0.2)', width: '36px', fontSize: '11px' }}>#</th>
                        {availableFields.filter(f => selectedCols.includes(f.key)).map(f => (
                          <th key={f.key} style={{ padding: '9px 12px', color: '#fff', fontWeight: 'bold', textAlign: 'right', borderLeft: '1px solid rgba(255,255,255,0.2)', whiteSpace: 'nowrap', fontSize: '11px' }}>
                            {f.label}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((row, ri) => (
                        <tr key={ri} style={{ background: ri % 2 === 0 ? C.white : C.bg, borderBottom: `1px solid ${C.bg}` }}>
                          <td style={{ padding: '8px 12px', color: C.muted, fontSize: '11px', textAlign: 'center' }}>{ri + 1}</td>
                          {availableFields.filter(f => selectedCols.includes(f.key)).map(f => {
                            let val = row[f.key] ?? '—';
                            if (f.type === 'date' && val && val !== '—') val = fmtDate(val);
                            if (f.key === 'status') val = val==='active'||val==='approved'?'✅ مكتمل':val==='pending'?'⏳ معلق':'❌ مرفوض';
                            if (f.key === 'method') val = val==='card'?'💳 كارت':val==='vodafone'?'📱 فودافون':'🏦 تحويل';
                            if (f.key === 'is_active') val = val?'✅ نشط':'⏸️ موقوف';
                            if (f.key === 'amount') val = `${Number(val||0).toLocaleString('ar-EG')} جنيه`;
                            const isNum = f.type === 'number';
                            const isStatus = f.key === 'status' || f.key === 'is_active';
                            return (
                              <td key={f.key} style={{ padding: '8px 12px', color: isNum ? C.green : C.text, fontWeight: isNum ? '600' : '400', whiteSpace: 'nowrap', textAlign: isStatus ? 'center' : 'right' }}>
                                {val}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            }
          </div>
        )}
      </div>
    </div>
  );
}
